<template>
  <div>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      :disabled="disabled"
      label-position="top"
    >
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item label="策略顺序" prop="transferSeqno">
            <el-input-number
              v-model="form.transferSeqno"
              placeholder="请输入执行顺序"
              clearable
              size="small"
              style="width:100%"
              controls-position="right"
              :max="2147483647"
              :min="1"
              :step-strictly="true"
              :step="1"
            >
            </el-input-number>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item label="子单组织机构" prop="stepOrgCode">
            <org-cascader
              :valueString.sync="form.stepOrgAllCode"
              :lastValue.sync="form.stepOrgCode"
            />
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item label="子单业务类型" prop="stepBusinessType">
            <dict-select
              filterable
              v-model="form.stepBusinessType"
              placeholder="请选择子单业务类型"
              default
              :body="stepBusinessTypeDictParams"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item label="交接时效方式" prop="stepScheduleType">
            <el-select
              filterable
              v-model="form.stepScheduleType"
              placeholder="请选择交接时效方式"
              clearable
              size="small"
              style="width:100%"
            >
              <el-option label="默认时效方式" value="A"></el-option>
              <el-option label="时间节点方式" value="B"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          :sm="{ span: 24 }"
          :md="{ span: 12 }"
          :lg="{ span: 8 }"
          v-if="scheduleType"
        >
          <el-form-item label="子单时效要求">
            <el-input-number
              v-model="form.stepTransportHours"
              placeholder="请输入子单时效要求"
              clearable
              size="small"
              style="width:100%"
              controls-position="right"
              :max="2147483647"
              :min="0"
              :step-strictly="true"
              :step="1"
            >
            </el-input-number>
          </el-form-item>
        </el-col>

        <el-col
          :sm="{ span: 24 }"
          :md="{ span: 12 }"
          :lg="{ span: 8 }"
          v-if="scheduleType"
        >
          <el-form-item label="中转站停留时效">
            <el-input-number
              v-model="form.stepWaitingHours"
              placeholder="请输入中转站停留时效"
              clearable
              size="small"
              style="width:100%"
              controls-position="right"
              :max="2147483647"
              :min="0"
              :step-strictly="true"
              :step="1"
            >
            </el-input-number>
          </el-form-item>
        </el-col>

        <el-col
          :sm="{ span: 24 }"
          :md="{ span: 12 }"
          :lg="{ span: 8 }"
          v-if="!scheduleType"
        >
          <el-form-item label="送达时间">
            <el-col>
              <plan-time
                :day.sync="form.stepReceivingDay"
                :hour.sync="form.stepReceivingHour"
                :minute.sync="form.stepReceivingMinute"
              />
            </el-col>
          </el-form-item>
        </el-col>

        <el-col
          :sm="{ span: 24 }"
          :md="{ span: 12 }"
          :lg="{ span: 8 }"
          v-if="!scheduleType"
        >
          <el-form-item label="提货时间">
            <el-col>
              <plan-time
                :day.sync="form.nextStepPickUpDay"
                :hour.sync="form.nextStepPickUpHour"
                :minute.sync="form.nextStepPickUpMinute"
              />
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item label="中转站" prop="transferStationCode">
            <el-col>
              <dict-select
                filterable
                v-model="form.transferStationCode"
                url="/master/transfer/station/select"
                placeholder="请选择中转站"
              ></dict-select>
            </el-col>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item label="状态" prop="transferRuleStatus">
            <el-radio-group v-model="form.transferRuleStatus">
              <el-radio label="Y">有效</el-radio>
              <el-radio label="N">无效</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="backDialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>是否要保存更改</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small"
          >取消</el-button
        >
        <el-button @click="close()" size="small">不保存</el-button>
        <el-button @click="save()" type="primary" size="small">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import PlanTime from '../transfer-timeline/plan-time'
import validate from '@/libs/util.validate'
export default {
  components: { PlanTime },
  props: {
    disabled: { type: Boolean, default: false },
    transferRuleDetailCode: String,
    transferRuleCode: String,
  },
  data() {
    return {
      stepBusinessTypeDictParams: { type: 'stepBusinessType' },
      backDialogVisible: false,
      scheduleType: true,
      form: {
        transferRuleStatus: 'Y',
        stepScheduleType: 'A',
        transferRuleCode: this.transferRuleCode,
      },
      rules: {
        transferSeqno: [
          { required: true, message: '请输入执行顺序', trigger: 'blur' },
        ],
        stepOrgCode: [
          {
            required: true,
            message: '请选择该步骤负责处理机构',
            trigger: 'change',
          },
        ],
        stepBusinessType: [
          {
            required: true,
            message: '请选择该步骤负责处理的业务类型',
            trigger: 'change',
          },
        ],
        stepScheduleType: [
          { required: true, message: '请选择交接时效方式', trigger: 'change' },
        ],
        transferStationCode: [
          { required: true, message: '请选择中转站', trigger: 'change' },
        ],
        transferRuleStatus: [
          { required: true, message: '请选择有效状态', trigger: 'change' },
        ],
      },
    }
  },
  watch: {
    'form.stepScheduleType'() {
      if (this.form.stepScheduleType === 'B') {
        this.scheduleType = false
        this.form.stepTransportHours = 0
        this.form.stepWaitingHours = 0
      } else {
        this.scheduleType = true
        this.form.stepReceivingDay = ''
        this.form.stepReceivingHour = ''
        this.form.stepReceivingMinute = ''
        this.form.nextStepPickUpDay = ''
        this.form.nextStepPickUpHour = ''
        this.form.nextStepPickUpMinute = ''
      }
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.transferRuleDetailCode) return
      this.$api
        .masterTransferRuleDetailDetailApi({
          transferRuleDetailCode: this.transferRuleDetailCode,
        })
        .then((res) => {
          this.form = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)
      let loadingInstance = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      this.$api
        .masterTransferRuleDetailSaveApi(this.form)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
